module.exports = __webpack_public_path__ + "img/Pic_Text_ZCFT_Title.09f5862e.png";